import gql from 'graphql-tag';

// Analytic tool require some of these fields so change at your own risk
export const ProfileFragment = gql`
	fragment ProfileFragment on ProfileType {
		avatarUrl
		smallAvatarUrl
		email
		firstName
		lastName
		countryCode
		phoneNumber
		psId
		organization {
			name
			userOrganizationRole
			psId
			type
			aiChatEnabled
			viewsEnabled
		}
		team {
			psId
			teamType
		}
		policyAccepted
		followingBuildings {
			id
			name
		}
	}
`;
// this is the end. If you changed it, I hope you know what you're doing.

export const UserProfileQuery = gql`
	query UserProfileQuery {
		profile {
			...ProfileFragment
		}
	}
	${ProfileFragment}
`;

export const UserPolicyAcceptedMutation = gql`
	mutation userPolicyMutation {
		userPolicyAccept {
			success
			profile {
				...ProfileFragment
			}
		}
	}
	${ProfileFragment}
`;

export const UpdateProfileMutation = gql`
	mutation UpdateProfileMutation(
		$firstName: String
		$image: Boolean
		$lastName: String
		$countryCode: String
		$phoneNumber: String
		$file: Upload
	) {
		updateProfile(
			firstName: $firstName
			image: $image
			lastName: $lastName
			countryCode: $countryCode
			phoneNumber: $phoneNumber
			file: $file
		) {
			success
			profile {
				...ProfileFragment
			}
		}
	}
	${ProfileFragment}
`;

export const FollowBuildingMutation = gql`
	mutation followBuilding($buildingId: UUID!) {
		followBuilding(buildingId: $buildingId) {
			success
			profile {
				followingBuildings {
					id
					name
				}
			}
		}
	}
`;

export const UnfollowBuildingMutation = gql`
	mutation unfollowBuilding($buildingId: UUID!) {
		unfollowBuilding(buildingId: $buildingId) {
			success
			profile {
				followingBuildings {
					id
					name
				}
			}
		}
	}
`;

export const IntercomKey = gql`
	query intercomKey {
		intercomKey
	}
`;
